module.exports = __webpack_public_path__ + "img/pro2.e8f7949c.jpg";